import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import useResponsiveness from '@/hooks/useResponsiveness';

const createStyles = (colors, isSM) => StyleSheet.create({
  creditCard: {
    alignItems: 'center',
    gap: 15,
    height: isSM ? 50 : 66,
    marginBottom: 25,
    overflow: 'hidden',
    flexDirection: 'row',
    backgroundColor: colors.solid_color_tertiary,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: colors.border_color_secondary,
  },
  purchasedCreditsIcon: {
    padding: isSM ? 10 : 15,
    height: '100%',
    width: isSM ? 50 : 65,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors.accent_color_primary + '15',
  },
  creditValueContainer: {
    marginLeft: 'auto',
    flexDirection: 'column',
    paddingRight: 15,
    paddingVertical: 10,
  },
  creditValueNumber: {
    textAlign: 'right',
  },
});

function CreditDisplayCard({ credits, icon, text }) {
  const { colors } = useTheme();
  const { isSM } = useResponsiveness();
  const styles = useMemo(() => createStyles(colors, isSM), [colors, isSM]);

  return (
    <View style={styles.creditCard}>
      <View style={styles.purchasedCreditsIcon}>
        <Icon name={icon} size={isSM ? 20 : 28} color={colors.text_color_primary} />
      </View>
      <View style={styles.creditValueContainer}>
        <Text style={styles.creditValueNumber} color="primary" size={isSM ? 'l' : 'xxl'} weight='extraBold'>
          {credits}
        </Text>
        <Text size={isSM ? 'xs' : 's'} color="secondary">
          {text}
        </Text>
      </View>
    </View>
  );
} 

export default React.memo(CreditDisplayCard);